import {IndividualTastingContext} from 'modules/events/context/IndividualTasting';
import {IWineShop} from 'modules/wineshops-list/models';
import {FC, ReactNode, useMemo, useState} from 'react';

interface IProps {
    children: ReactNode;
}

export const IndividualTastingProvider: FC<IProps> = ({children}) => {
    const [isSelectWineShopOpen, setIsSelectWineShopOpen] = useState(false);
    const [selectedWineShop, setSelectedWineShop] = useState<IWineShop | undefined>();

    const value = useMemo(() => {
        return {
            isSelectWineShopOpen,
            selectedWineShop,
            setIsSelectWineShopOpen,
            setSelectedWineShop,
        };
    }, [isSelectWineShopOpen, selectedWineShop]);

    return <IndividualTastingContext.Provider value={value}>{children}</IndividualTastingContext.Provider>;
};
